import { render, staticRenderFns } from "./OrderDeliveryTime.vue?vue&type=template&id=3d2bc216&scoped=true&"
import script from "./OrderDeliveryTime.vue?vue&type=script&lang=js&"
export * from "./OrderDeliveryTime.vue?vue&type=script&lang=js&"
import style0 from "./OrderDeliveryTime.vue?vue&type=style&index=0&id=3d2bc216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2bc216",
  null
  
)

export default component.exports